export default "__VITE_ASSET__zB1nf0jc__"